import { Navigate } from 'react-router-dom';

import { readPersistedAuth } from '@/features/auth/auth.storage';
import { LandingPage } from '@/features/landing/LandingPage';

/**
 * "/" is the public landing page — except for signed-in staff, whose
 * bookmarks of the root URL still open the review queue, as they did before
 * the landing page existed. A demo visitor who comes back to "/" sees the
 * landing page again.
 */
export const RootRoute = () => {
  const { token, role } = readPersistedAuth();
  if (token && role === 'salesman') return <Navigate to="/capture" replace />;
  return token && role !== 'demo' ? <Navigate to="/orders" replace /> : <LandingPage />;
};
